export default {
  api_keys: "Claves API",
  api_docs: "Documentación",
  keys_count: "{current} / {total} claves",
  unnamed: "Sin nombre",
  edit_name: "Editar nombre",
  upgrade_to_enable: "Actualice para habilitar la función de claves API",
  no_api_keys: "Sin claves API",
  generate_key: "Generar clave",
  upgrade_to_generate: "Actualice para generar una clave",
  api_calls: "Llamadas API",
  endpoint_stats: "Estadísticas de llamadas a endpoints",
  refresh: "Actualizar",
  free_plan_api_stats:
    "Los usuarios del plan gratuito no pueden ver estadísticas de llamadas API. Por favor actualice para ver datos detallados.",
  data_updates: "Actualización de datos cada 5 minutos",
  api_call_logs: "Registros de llamadas API",
  api_call_logs_desc:
    "Aquí solo se pueden ver solicitudes con claves API válidas. Los datos se actualizan cada 5 minutos",
  select_api_key: "Seleccionar clave API",
  endpoint: "Endpoint",
  response_time: "Tiempo de respuesta",
  api_quota: "Cuota API",
  upgrade: "Actualizar",
  current_plan: "Plan actual",
  key_count: "Número de claves",
  call_limit: "Límite de llamadas",
  no_access: "Sin acceso",
  daily_limit: "{limit} llamadas por día",
  total_limit: "Límite total {limit} llamadas",
  monthly_limit: "{limit} llamadas por mes",
  calc_quota: "Cuota de cálculo",
  calc_and_report_quota: "Cuota de cálculo e informe",
  report_quota: "Cuota de informe",
  daily_report_quota: "Informes diarios",
  extra_quota: "Cuota adicional: {count} llamadas",
  edit_key_name: "Editar nombre de clave",
  key_name: "Nombre de clave",
  key_name_placeholder: "Por favor ingrese un nombre para la clave",
  key_name_desc: "Asigne un nombre reconocible a su clave API",
  feature_restricted: "Función restringida",
  feature_restricted_desc1: "Su plan actual no puede usar esta función",
  feature_restricted_desc2:
    "Los usuarios del plan gratuito no pueden usar funciones de claves API. Por favor actualice a un plan de pago para desbloquear todas las funciones.",
  upgrade_benefits: "Beneficios de actualizar:",
  benefit1: "Generar y gestionar claves API",
  benefit2: "Ver estadísticas y tendencias de llamadas API",
  benefit3: "Copiar y usar claves API",
  benefit4: "Cuotas más altas de cálculo e informes",
  benefit5: "Funciones más avanzadas",
  response_data_details: "Detalles de datos de respuesta",
  call_count: "{count} llamadas",
  name_required: "El nombre no puede estar vacío",
  name_too_long: "La longitud del nombre no puede exceder los 20 caracteres",
  key_generated: "Clave generada con éxito",
  key_deleted: "Eliminada con éxito",
  key_updated: "Nombre actualizado con éxito",
  upgrade_required: "Por favor actualice",
  loading_docs: "Cargando documentación API...",
  docs_load_error: "Error al cargar la documentación",
  docs_load_error_desc:
    "Ocurrió un error al cargar la documentación API. Por favor intente nuevamente.",
  close_window: "Cerrar ventana",
  delete_confirm: "¿Confirmar eliminación?",
  today: "Hoy",
  this_month: "Este mes",
  usage: "Uso",
  plan_quota: "Cuota del plan: {count} llamadas",
  name: "Nombre",
  api_key: "Clave API",
  created_at: "Creado el",
  action: "Acción",
  response_status: "Código de estado",
  response_data: "Datos de respuesta",
  call_count_name: "Número de llamadas",
  update_failed: "Error al actualizar",
  restricted: "Restringido",
};
